/**
 * CPT-table row error aggregation used to disable save when any cell is invalid.
 * @module hasTableAnyError
 */
import { CptCodesTableRowModel } from "../../../../../data-model/cptCodesTableModel";

/**
 * Returns true when any CPT row has a validation error on a save-blocking
 * field (dates, visits, J-code, Auth#, or Filing Info).
 *
 * @param data - Current CPT table rows
 * @return True if at least one row reports `hasError` on a checked cell
 */
export const hasAnyError = (data: CptCodesTableRowModel[]): boolean => {
  return data.some(
    (row) =>
      row.startFrom.hasError ||
      row.endAt.hasError ||
      row.visits.hasError ||
      row.remainingVisits.hasError ||
      row.visitsAllowed.hasError ||
      row.jCodes.hasError ||
      row.authorizationNumber?.hasError ||
      row.filingInfo?.hasError,
  );
};
